










































import Vue from 'vue';
import AsyncBtn from '../components/AsyncBtn.vue';
import { login } from '.';

interface Data {
  email: string,
  password: string,
  remember: boolean,
  task: Promise<void>|null,
  redirect: string,
}

export default Vue.extend({
  meta: {
    title: 'Login',
  },
  data(): Data {
    return {
      email: '',
      password: '',
      remember: false,
      task: null,
      redirect: '/',
    };
  },
  methods: {
    login() {
      this.task = login(this.email, this.password, this.remember);
      if (this.task) {
        this.task.then(() => {
          this.$router.push(this.redirect);
        });
      }
    },
  },
  beforeRouteEnter(current: any, prev: any, next: any): void {
    next((vm: any) => {
      if (current.query.redirect) {
        vm.redirect = prev.fullPath;
      }
      if (current.query.target) {
        vm.redirect = current.query.target;
      }
    });
  },
  components: {
    AsyncBtn,
  },
});
